<p>
  @if (auction.whatToShow.includes('1')) {
    You currently have no upcoming or recently ended bidding activities. Bidding details will appear here when bidding activities have been scheduled for you within 14 days of today's date.
    <ng-container [ngTemplateOutlet]="conflicts" [ngTemplateOutletContext]="{auction:auction}"></ng-container>
  }
  @if (auction.whatToShow.includes('2')) {
    <ng-container [ngTemplateOutlet]="conflicts" [ngTemplateOutletContext]="{auction:auction}"></ng-container>
    Bidding will start on {{ auction.nextRound.BiddingStart | localTimeZone: 'full-date'}} for {{auction.nextRound.Name}} of {{auction.currentAuction.Rounds.length}} total rounds.
  }
  @if (auction.whatToShow.includes('3')) {
    Bidding is currently open for {{auction.currentRound.Name}} of {{auction.currentAuction.Rounds.length}} total rounds. You can bid on your classes until {{auction.currentRound.ProcessingStart | localTimeZone: 'full-date'}}.
    <ng-container [ngTemplateOutlet]="conflicts" [ngTemplateOutletContext]="{auction:auction}"></ng-container>
  }
  @if (auction.whatToShow.includes('4') || auction.whatToShow.includes('9')) {
    Bidding has ended for
    @if (auction.whatToShow.includes('4')) {
      {{auction.currentRound.Name}} of {{auction.currentAuction.Rounds.length}} total rounds,
    }
    @if (auction.whatToShow.includes('9')) {
      {{auction.currentRound.Name}} (the last round),
    }
    and the system is currently calculating the winners and losers.
    Conflict reconciliation starts on {{ auction.currentRound.StudentRecStart | localTimeZone: 'full-date'}}.
    <ng-container [ngTemplateOutlet]="conflicts" [ngTemplateOutletContext]="{auction:auction}"></ng-container>
  }
  @if (auction.whatToShow.includes('5') || auction.whatToShow.includes('10')) {
    <ng-container [ngTemplateOutlet]="conflicts" [ngTemplateOutletContext]="{auction:auction}"></ng-container>
    @if (auction.currentAuction.ConflictCount > 0) {
      You have until {{auction.currentRound.SystemRecStart | localTimeZone: 'full-date'}} to reconcile any conflicts. Otherwise, the system will remove conflicts at random.
    }
  }
  @if (auction.whatToShow.includes('6') || auction.whatToShow.includes('11')) {
    @if (auction.whatToShow.includes('6')) {
      {{auction.currentRound.Name}} of {{auction.currentAuction.Rounds.length}} total rounds
    }
    @if (auction.whatToShow.includes('11')) {
      {{auction.currentRound.Name}} (the last round)
    }
    is currently being finalized by program administrators.
    @if (auction.whatToShow.includes('6')) {
      Bidding will start up again with {{auction.nextRound.Name}} (of {{auction.currentAuction.Rounds.length}} total rounds) on {{ auction.nextRound.BiddingStart | localTimeZone: 'full-date'}}.
    }
    <ng-container [ngTemplateOutlet]="conflicts" [ngTemplateOutletContext]="{auction:auction}"></ng-container>
  }
  @if (auction.whatToShow.includes('7')) {
    Bidding for {{auction.nextRound.Name}} (the last round) will start on {{ auction.nextRound.BiddingStart | localTimeZone: 'full-date'}}.
    <ng-container [ngTemplateOutlet]="conflicts" [ngTemplateOutletContext]="{auction:auction}"></ng-container>
  }
  <!-- There is no message for 8 -- instead we reuse message #3-->
  @if (auction.whatToShow.includes('12')) {
    Bidding ended on {{ auction.previousRound.SystemRecEnd | localTimeZone: 'full-date'}}. If you don't already see your new enrollments, they should be posted soon.
    <ng-container [ngTemplateOutlet]="conflicts" [ngTemplateOutletContext]="{auction:auction}"></ng-container>
  }

  <ng-template #conflicts let-auction="auction">
    <span class="detail">
      @if (auction.currentAuction && ( auction.whatToShow.includes('m1') || auction.whatToShow.includes('m2') || auction.whatToShow.includes('C'))) {
        <span class="highlight">
          @if ((auction.whatToShow.includes('m2') || auction.whatToShow.includes('C'))  && auction.currentAuction.ConflictCount > 0) {
            You have {{auction.currentAuction.ConflictCount}} conflicts that must be resolved.
          }
          @if ((auction.whatToShow.includes('m2') || auction.whatToShow.includes('C')) && auction.currentAuction.ConflictCount <= 0) {
            Congratulations -- you have no conflicts to resolve!
          }
          @if (auction.whatToShow.includes('m1')) {
            You currently have {{auction.currentAuction.CurrentBidPoints}} of {{auction.currentAuction.StartingBidPoints}} points.
          }
        </span>
      }
    </span>
  </ng-template>
</p>
